import { render, staticRenderFns } from "./img.vue?vue&type=template&id=4f3ab694&scoped=true&"
import script from "./img.vue?vue&type=script&lang=ts&"
export * from "./img.vue?vue&type=script&lang=ts&"
import style0 from "./img.vue?vue&type=style&index=0&id=4f3ab694&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ab694",
  null
  
)

export default component.exports